import ac from 'argument-contracts';
import {
    DEFAULT_KEY_METRIC,
    isValidKeyMetric
} from '../../key-metric';

/**
 * @callback PrDocumentListItemClick
 * @description
 * Custom behavior to handle a click on a document.
 * @param {object} options - Options provided by the document list.
 * @param {string} options.key - The key of the document clicked.
 */

/**
 * A class to represent the visualization options for a document list
 *
 * @param {object} options - options object (See below)
 * @param {string|DEFAULT_KEY_METRIC} [options.keyMetric=DEFAULT_KEY_METRIC] - The key metric to display on the card
 * @param {string} [options.language='en'] - The language to use for translating labels
 * @param {PrDocumentListItemClick} [options.onPointClick=null] - A function to call when a point is clicked
 * @param {string} [options.yAxisTitle] The label for value being measured, if one was provided.
 */
export class DocumentListOptions {
    constructor({
        keyMetric = DEFAULT_KEY_METRIC,
        language = 'en',
        onPointClick = null,
        yAxisTitle
    } = {}) {
        ac.assertObject(arguments[0], 'options');

        if(!isValidKeyMetric(keyMetric) && typeof keyMetric !== 'string') {
            throw new RangeError(`options.keyMetric must be a valid KeyMetric value or string. Provided value: ${keyMetric}`);
        }

        const languageNames = new Intl.DisplayNames(['en'], { type: 'language', fallback: 'none' });
        if (languageNames.of(language) === undefined) {
            throw new RangeError(`options.language must be a valid ISO language code. Provided value: ${language}`);
        }

        if (onPointClick !== null) {
            ac.assertFunction(onPointClick, 'options.onPointClick');
        }

        if(yAxisTitle !== undefined) {
            ac.assertString(yAxisTitle, 'options.yAxisTitle');
        }

        this.keyMetric = keyMetric;
        this.language = language;
        this.onPointClick = onPointClick;
        this.yAxisTitle = yAxisTitle;

        Object.freeze(this);
    }
}
